import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { dispatchOffers, dispatchOfferSent, dispatchSelectedOffer } from 'tennders-market/offer/stores/action'
import { apiPost } from 'tennders-stracture/libs/api'

const useOffers = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const offers = useSelector((state) => state.offer.offers)
  const { transansaction } = useTransaction()
  const [pagination, setpagination] = useState({ totalItem: 0 })
  const setOffers = (data) => dispatch(dispatchOffers(data))
  const selectedOffer = useSelector((state) => state.offer.selectedOffer)
  const setSelectedOffer = (offer) => dispatch(dispatchSelectedOffer(offer))
  const isOfferSent = useSelector((state) => state.offer.isOfferSent)

  const setOfferSent = (value) => {
    dispatch(dispatchOfferSent(value))
    if (value) {
      setTimeout(() => {
        dispatch(dispatchOfferSent(false))
      }, 3000)
    }
  }

  const fetchOffers = async ({ id }) => {
    setLoading(true)
    const url = `/offers/transaction/${id}`
    const response = await apiPost(url, { perPage: 100 })
    setLoading(false)
    if (response.items) {
      setOffers(response.items)
      setpagination(response.meta?.pagination)
    }
  }

  const refreshOffer = async ({ transactionId, offerId, callback }) => {
    const url = `/offers/transaction/${transactionId}`
    const response = await apiPost(url, { perPage: 100 })
    if (response?.items) {
      response.items.forEach((singleOffer) => {
        if (singleOffer.id === offerId) {
          callback(singleOffer)
        }
      })
    }
  }

  const getInternalOffers = async ({ id }) => {
    const url = `/offers/transaction/internal/${id}`
    const response = await apiPost(url, { perPage: 100 })
    return Array.isArray(response) ? response : []
  }

  const getMiniMarketPlaceOffers = async ({ id }) => {
    const url = `/offers/transaction/mini-mp/${id}`
    const response = await apiPost(url, { perPage: 100 })
    return Array.isArray(response) ? response : []
  }

  const getMarketPlaceOffers = async ({ id }) => {
    const url = `/offers/transaction/market-place/${id}`
    const response = await apiPost(url, { perPage: 100 })
    return Array.isArray(response) ? response : []
  }

  const refreshOffers = async () => {
    fetchOffers(transansaction)
  }

  return {
    offers,
    loading,
    isOfferSent,
    setOfferSent,
    fetchOffers,
    refreshOffer,
    getInternalOffers,
    refreshOffers,
    selectedOffer,
    setSelectedOffer,
    pagination,
    getMiniMarketPlaceOffers,
    getMarketPlaceOffers
  }
}

export default useOffers
